module.exports = __webpack_public_path__ + "static/img/game5.c159a89e.png";